// Light/dark theme selection.
//
// Three states, and the third is the point: "system" follows the OS via the
// prefers-color-scheme media query in theme.css, while "light"/"dark" stamp
// data-theme on <html> to override it in EITHER direction (a user on a dark OS can
// still force light). The CSS selectors are written so data-theme always wins.
//
// Preference is per-browser (localStorage) — it is a display choice, not account
// data, so it never touches the server and costs the reconciliation nothing.

export type ThemeChoice = "system" | "light" | "dark";

const KEY = "cri_theme";

export function getTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);
  try {
    if (choice === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // Private mode / storage disabled: the theme still applies for this session.
  }
}

/** Apply the stored choice. Called once at startup, before first paint. */
export function initTheme(): void {
  applyTheme(getTheme());
}
